"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceJobView = void 0;
const typeorm_1 = require("typeorm/browser");
const accounting_document_1 = require("./accounting-documents/accounting-document");
let InvoiceJobView = class InvoiceJobView {
};
__decorate([
    (0, typeorm_1.Column)('bigint', {
        name: 'invoiceid',
    }),
    __metadata("design:type", String)
], InvoiceJobView.prototype, "invoiceId", void 0);
__decorate([
    (0, typeorm_1.Column)('varchar', {
        length: 18,
        name: 'job',
    }),
    __metadata("design:type", String)
], InvoiceJobView.prototype, "jobId", void 0);
__decorate([
    (0, typeorm_1.Column)('varchar', {
        length: 18,
        name: 'account',
    }),
    __metadata("design:type", String)
], InvoiceJobView.prototype, "accountId", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        name: 'name',
    }),
    __metadata("design:type", String)
], InvoiceJobView.prototype, "documentNumber", void 0);
__decorate([
    (0, typeorm_1.Column)('date', {
        name: 'invoice_date',
    }),
    __metadata("design:type", String)
], InvoiceJobView.prototype, "documentDate", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        name: 'status',
        enum: accounting_document_1.AccountingDocumentTypeEnum,
    }),
    __metadata("design:type", String)
], InvoiceJobView.prototype, "status", void 0);
InvoiceJobView = __decorate([
    (0, typeorm_1.ViewEntity)({
        expression: `
        SELECT --manual DDL version 2
          doc.id as "invoiceid",
          doctojob.job__c_sfid as "job",
          doc.number as "name",
          doc.target_id as "target_id",
          doc.issue_date as "invoice_date",
          doc.status as "status"
        FROM
          accounting.accounting_document doc
          LEFT JOIN public.account account
            ON account.id = doc.target_id
          LEFT JOIN accounting.accounting_document_to_jobs doctojob
            ON doctojob.accounting_document_id = doc.id
          LEFT JOIN public.job__c job
            ON job.sfid = doctojob.job__c_sfid
          LEFT JOIN public.opportunity opp
            ON opp.sfid = job.opportunity__c
  `,
        name: 'invoice_jobs',
        schema: 'public',
    })
], InvoiceJobView);
exports.InvoiceJobView = InvoiceJobView;
//# sourceMappingURL=invoice-jobs-view.js.map